import React from 'react';
import PropTypes from 'prop-types';

import dataTypes from '../../../constants/dataTypes';
import { get } from '../../../utils/arrayUtil';
import { getDisplayValueForType } from '../../../utils/tableUtil';
import BooleanRequirements from '../../RequirementBlocks/InsurancePolicyBlock/BooleanRequirements';
import InsurancePolicyCard from '../../RequirementBlocks/InsurancePolicyBlock/InsurancePolicyCard';
import InsurancePolicyRequirements from '../../RequirementBlocks/InsurancePolicyBlock/InsurancePolicyRequirements';
import NonbooleanRequirements from '../../RequirementBlocks/InsurancePolicyBlock/NonbooleanRequirements';
import RequirementBlockCardHeader from '../../RequirementBlocks/RequirementBlockCardHeader';

import RequirementBlock from './RequirementBlock';

function RequiredCoverageInfoBlock({ minimumRequirements }) {
  return (
    <RequirementBlock title="Required Coverage">
      {Object.values(minimumRequirements).map(req => {
        const properties = Object.values(req.policyProperties);

        const booleanProperties = properties
          .filter(p => p.propertyDataType === dataTypes.Boolean)
          .map(prop => {
            if (get(prop, 'requiredValue', 0) > 0) {
              return (
                <BooleanRequirements displayName={prop.propertyDisplayName} key={prop.id} />
              );
            }

            return null;
          });

        const nonBooleanProperties = properties
          .filter(p => p.propertyDataType !== dataTypes.Boolean)
          .map(prop => {
            const propertyName = prop.propertyDisplayName;
            const propertyValue = getDisplayValueForType(prop.requiredValue, prop.propertyDataType) ?? '-';
            return (
              <NonbooleanRequirements
                key={prop.id}
                propertyName={propertyName}
                propertyValue={propertyValue}
              />
            );
          });

        return (
          <div key={req?.id}>
            <InsurancePolicyCard>
              <RequirementBlockCardHeader displayName={req.policyTypeDisplayName} isRequired={req.required} />
              <InsurancePolicyRequirements
                booleanProperties={booleanProperties}
                nonBooleanProperties={nonBooleanProperties}
              />
            </InsurancePolicyCard>
          </div>
        );
      })}
    </RequirementBlock>
  );
}

RequiredCoverageInfoBlock.propTypes = { minimumRequirements: PropTypes.shape({}) };

export default RequiredCoverageInfoBlock;
